
import { useState } from "react";
import { Key, ReactChild, ReactFragment, ReactPortal, useCallback, useEffect, useMemo, useLayoutEffect } from 'react';
import { useNavigate } from "react-router-dom";
import './styles.css'
import Grid from '@material-ui/core/Grid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faWallet } from '@fortawesome/free-solid-svg-icons'
import { MenuList, MenuListItem, Separator, styleReset, Window, WindowHeader, WindowContent, Frame, Button } from 'react95';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { Alert, SliderThumb } from "@material-ui/core";
import '@react95/icons/icons.css';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
/* Pick a theme of your choice */
import brick from 'react95/dist/themes/brick';
import blue from 'react95/dist/themes/blue';
import original from 'react95/dist/themes/original';
import millenium from 'react95/dist/themes/millenium';
import vaporTeal from 'react95/dist/themes/vaporTeal';
import modernDark from 'react95/dist/themes/modernDark';
import azureOrange from 'react95/dist/themes/azureOrange';
import denim from 'react95/dist/themes/denim';
import coldGray from 'react95/dist/themes/coldGray';
import matrix from 'react95/dist/themes/matrix';
import rainyDay from 'react95/dist/themes/rainyDay';
import aiee from 'react95/dist/themes/aiee';
import slate from 'react95/dist/themes/slate';
import shelbiTeal from 'react95/dist/themes/shelbiTeal';

import { Avatar } from "react95";
import React from "react";
import { Mail, Mail2, CdMusic, cdMusicData, MediaVideo, mediaVideoData, Mic } from '@react95/icons';
import { GlobeSimple, InstagramLogo, TwitterLogo, TiktokLogo, SoundcloudLogo, DiscordLogo, SpotifyLogo, AppleLogo, YoutubeLogo, GithubLogo  } from "@phosphor-icons/react";
import axios from "axios"; 

const LIVE_PERFORMANCES = [
  { name: "Dolphin Mall", city: "Miami, FL", year: "2026" },
  { name: "The Sound Library", city: "Miami, FL", year: "2026" },
  { name: "Calle 8 Ecuadorian Festival", city: "Miami, FL", year: "2025" },
  { name: "Young Arts", city: "Miami, FL", year: "2014" },
  { name: "America Teve Minuto de Fama", city: "Miami, FL", year: "2010" },
  { name: "Dear Eleanor", city: "Miami, FL", year: "2025" },
  { name: "Unseen Creatures Brewery", city: "Miami, FL", year: "2023" },
  { name: "Unbranded Brewery", city: "Miami, FL", year: "2024" },
  { name: "Tea & Poets", city: "Miami, FL", year: "2018" },
  { name: "The Pride Center at Equality Park", city: "Fort Lauderdale, FL", year: "2026" },
  { name: "Esquina de Abuela", city: "Miami, FL", year: "2021" },
  { name: "Thank You Miami", city: "Miami, FL", year: "2026" },
];

const EPK = (props) => {
  const [email, setEmail] = useState("");
  const [fan, setFan] = useState(false);
  const [producer, setProducer] = useState(false);
  const [artist, setArtist] = useState(false);
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState("");

  useEffect(() => {
    
    //hide elements
    if(document){
      const welcomeBox = document.getElementById("welcomeBox");
      welcomeBox.style.display = "none";
    }
  }, []);

  useEffect(() => {
    
    //hide elements
    if(email){
    console.log(email);
    }
    if(producer){
      console.log(producer)
    }
    if(artist){
      console.log(artist)
    }
  }, );

  function handleOpenDialog(){
    //<a href="https://www.beatstars.com/genwav/sound-kits/179946" target="_blank" style={{textDecoration:"none", cursor:"pointer"}}></a>
    if(document){
      const dialog = document.querySelector("dialog")
      dialog.showModal();
    }
  }

  function handleCloseSignUp() {
    if(document){
      const dialog = document.querySelector("dialog")
      dialog.close();
    }
  }

  function handleSubmit() {
    const dataToSend = {
      email: email,
      subject: producer,
      body: artist
    };
  
    // Make a POST request using Axios
    axios.post('https://localhost:3001/sendEmail', dataToSend)
      .then((response) => {
        // Handle the response if needed
        console.log('Request successful', response.data);
        setMessage('Your e-mail has been saved!')
        window.open("https://www.beatstars.com/genwav/sound-kits/179946", "_blank")
      })
      .catch((error) => {
        // Handle errors
        console.error('Error: ', error);
        window.alert(error);
        setAlert('Error: ', error)
      });

    setAlert('There was an error.');

  }
 
  const pdfUrl = 'https://www.dropbox.com/scl/fi/4lwen7hpp9unl5nchcnk0/GENWAV-EPK-2025.pdf?rlkey=ttotkbmuunc0zzocoefmn07xv&st=kwe51n2x&dl=0';
  
  // Newsletter signup + social links: shown in the middle column on desktop, and
  // at the bottom (after Press / Live Performances, before the photos) on mobile
  const signupAndLinks = (
    <>
            <div
              className="card epk-newsletter"
              style={{ boxSizing: "border-box", minHeight: "200px", margin: "5% auto 0" }}
            >
              <div className="cardHeader">
                <iframe
                  title="gen.wav newsletter signup"
                  loading="lazy"
                  src="https://influanto.com/embed/newsletter/gen.wav"
                  width="100%"
                  height="520"
                  frameBorder="0"
                  style={{ border: "none", maxWidth: "100%" }}
                ></iframe>
              </div>
            </div>

           <div className="epk-socials" style={{paddingTop:"10px", marginTop:"3%", display:"flex", justifyContent:"space-between"}}>
                <div style={{display:"inline"}}>
                  <a target="_blank" href="http://instagram.com/gen.wav" style={{textDecoration:"none"}}>
                    <InstagramLogo style={{color: 'purple'}} size={25}></InstagramLogo>
                  </a>
                </div>
                <div style={{display:"inline"}}>
                  <a target="_blank" href="http://twitter.com/gendotwav" style={{textDecoration:"none"}}>
                    <TwitterLogo style={{color: '#A6CAF0'}} size={25}></TwitterLogo>
                  </a>
                </div>
                <div style={{display:"inline"}}>
                  <a target="_blank" href="http://tiktok.com/@gen.wav" style={{textDecoration:"none"}}>
                    <TiktokLogo style={{color: 'pink'}} size={25}></TiktokLogo>
                  </a>
                </div>
                <div style={{display:"inline"}}>
                  <a target="_blank" href="https://soundcloud.com/genwav" style={{textDecoration:"none"}}>
                    <SoundcloudLogo style={{color: 'orange'}} size={25}></SoundcloudLogo>
                  </a>
                </div>
                <div style={{display:"inline"}}>
                  <a target="_blank" href="https://www.youtube.com/@genwav" style={{textDecoration:"none"}}>
                    <YoutubeLogo style={{color: 'red'}} size={25}></YoutubeLogo>
                  </a>
                </div>
                <div style={{display:"inline"}}>
                  <a target="_blank" href="https://open.spotify.com/artist/3YihJDU9YETUNDWO6pDuQG?si=VmY6439rRLS5mw8uC0nHYg" style={{textDecoration:"none"}}>
                    <SpotifyLogo style={{color: 'green'}} size={25}></SpotifyLogo>
                  </a>
                </div>
                <div style={{display:"inline"}}>
                  <a target="_blank" href="https://music.apple.com/us/artist/genesis-barrios/1194186719" style={{textDecoration:"none"}}>
                    <AppleLogo style={{color: 'pink'}} size={25}></AppleLogo>
                  </a>
                </div>
                <div style={{display:"inline"}}>
                  <a target="_blank" href="https://discord.com/invite/2MdNjbHnBR" style={{textDecoration:"none"}}>
                    <DiscordLogo style={{color: 'purple'}} size={25}></DiscordLogo>
                  </a>
                </div>
              </div>
    </>
  );

  const bookings = (
    <>
          <h1 style={{marginTop:"5%"}}>BOOKINGS & PRESS INQUIRIES</h1>
          <p style={{marginBottom:"1.5%"}}><a style={{color:"white", textDecoration:"none"}} href="mailto:beatsbygenwav@gmail.com">beatsbygenwav@gmail.com</a></p>

          <a
              href={pdfUrl}
              target="_blank" // Opens the link in a new tab
              rel="noopener noreferrer" // Required for security reasons when using target="_blank"
              style={{
                backgroundColor: 'black',
                color: 'white',
                border: '1px solid white',
                borderRadius: '5px',
                padding: '10px 20px',
                display: 'inline-block',
                margin: '0',
                textDecoration: 'none' // Removes underline from anchor element
              }}
            >
              DOWNLOAD ELECTRONIC PRESS KIT
            </a>
    </>
  );

  return(
    
    <div id="EPK" style={{paddingBottom:"5%"}}>
      <style>{`
        .epk-mobile-photos { display: none; }
        .epk-newsletter { width: 50%; }
        .epk-signup-mobile { display: none; }
        .epk-mobile-hero { display: none; }
        .epk-bookings-mobile { display: none; }
        @media (max-width: 959.95px) {
          .epk-side-photos { display: none !important; }
          .epk-mobile-photos { display: block; }
          .epk-mobile-hero { display: block; width: 100%; height: 20vh; max-height: 180px; object-fit: cover; object-position: 55% 35%; border-radius: 8px; margin-bottom: 16px; }
          .epk-newsletter { width: 100%; }
          .epk-signup-desktop { display: none; }
          .epk-bookings-desktop { display: none; }
          .epk-bookings-mobile { display: block; margin-top: 8%; }
          .epk-signup-mobile { display: block; margin-top: 6%; text-align: left; }
        }
      `}</style>
          
      <Grid container spacing={3} style={{padding: "0px"}}> 
        <Grid item sm={12} md={4} lg={3} className="epk-side-photos"> 
          <div style={{height: "100vh", position: "sticky", top: 0}}>
            <img
              src="/KEEPGRINDING/DSC01454-web.jpg"
              alt="gen.wav"
              style={{height: "50vh", width: "100%", objectFit: "cover", objectPosition: "55% 50%"}}
            />
            <img 
              src="https://dl.dropboxusercontent.com/s/lgduzrail9tglaoo4orpg/IMG_5547.jpg?rlkey=mk5oacojh1yr23ij8s7vcyflt&dl=0"
              alt="image"
              style={{height: "50vh", width: "100%", objectFit: "cover"}}
            />  
          </div>
        </Grid>
        <Grid item sm={12} md={6} lg={6}> 
         <div style={{height:"100%", width: "100%"}}>
          <img className="epk-mobile-hero" src="/KEEPGRINDING/DSC01454-web.jpg" alt="gen.wav" />
          <h1>gen.wav</h1>
          <p style={{marginBottom:"2%"}}>Miami based Independent Artist, and Producer - Latin, Hip Hop, R&B, Alternative</p>
          
          <h1>ABOUT</h1>
          <p style={{marginBottom:"2%"}}>gen.wav is a Trans Cuban-Nicaraguan-American singer, multi-instrumentalist, and producer rooted in Miami, FL, where his bilingual upbringing shapes every corner of his work. A decade of classical training across piano, cello, violin, and music theory sits beneath a self-taught command of guitar, bass, and production, giving his Latin R&B and hip-hop sound a harmonic depth that sets him apart in Miami's independent scene. Writing freely in both Spanish and English, he draws on his Cuban and Nicaraguan heritage to craft music that refuses to separate cultural identity from personal and political honesty. Featured in Spotify Editorial Playlists, and Colors Studios.</p>
          <p style={{marginBottom:"2%"}}>gen.wav es un cantante trans, multi-instrumentista y productor cubano-nicaragüense-estadounidense que vive en Miami, Florida. Experimenta con muchos géneros latinos, urbanos y electrónicos, manteniéndose fiel a sus raíces latinas en Miami y escribiendo tanto en español como en inglés. Está fuertemente influenciado por el R&B, el Hip Hop, Salsa, Bachata, Reggaeton, Jazz y House. gen es tradicionalmente un músico clásico con más de 10 años de formación clásica en piano, violonchelo y voz, y lleva más de una década produciendo y escribiendo música original.</p>
          
          <h1>HIGHLIGHTS</h1>
          <p style={{marginBottom:"1%"}}>Featured on Spotify's Editorial Playlist New Music Friday Latin</p>
          <p style={{marginBottom:"1%"}}>Featured on Spotify's Editorial Playlist Spotify Novedades Viernes Latinoamerica</p>
          <p style={{marginBottom:"1%"}}>1 Million Streams on Soundcloud</p>
          <p style={{marginBottom:"1%"}}>1 Million Views on YouTube</p>
          <p style={{marginBottom:"1%"}}>Debut Album Released on May 30th 2024, was featured on Colors Studios and has surpassed 30K streams.</p>
          <p style={{marginBottom:"2%"}}>45,000+ Followers on Social Media</p>

          <h1 style={{marginTop:"5%"}}>MUSIC</h1>
          <iframe
            width="100%"
            src="https://www.youtube.com/embed/videoseries?list=PLcGBMxEyx5p8Wknn5d3dhCnj4noeArd3Q"
            title="gen.wav Official Music Videos"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            style={{marginTop:"0", aspectRatio:"16 / 9", height:"auto", display:"block"}}
          ></iframe>
          <iframe
            width="100%"
            src="https://www.youtube.com/embed/videoseries?list=PLFVcs9Ufxr3M"
            title="gen.wav Live Performances"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            style={{marginTop:"5%", aspectRatio:"16 / 9", height:"auto", display:"block"}}
          ></iframe>
          <iframe style={{marginTop:"5%"}} src="https://open.spotify.com/embed/artist/3YihJDU9YETUNDWO6pDuQG?utm_source=generator" width="100%" height="180" frameBorder="0" allow="clipboard-write; encrypted-media; picture-in-picture" loading="lazy"></iframe>
       
          <iframe width="100%" height="315" src="https://www.youtube.com/embed/videoseries?list=PLcGBMxEyx5p8fc_zHMGJAUxLs94iw_puY&si=r8E1lj8nOVJFXF7t&controls=1" title="YouTube video player" showControls frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          <iframe
            title="SoundCloud Player"
            width="100%"
            height="300"
            allow="autoplay"
            style={{marginTop:"5%", borderRadius:"10px"}}
            src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1657973560&color=%235ab7ce&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
          ></iframe>
          <div className="epk-bookings-desktop">{bookings}</div>

            <div className="epk-signup-desktop">{signupAndLinks}</div>
         </div>
        </Grid>
        <Grid item sm={12} md={3} lg={3}> 
        <div style={{height:"100%", width: "100%", paddingTop:"0", marginTop:"0", textAlign:"center"}}>
          <div style={{width:"100%", margin:"0 auto"}}>
            <h1 style={{marginBottom:"3%"}}>PRESS</h1>
             <h5 style={{marginBottom:"2%"}}><a href="https://somoslahoficial.com/blog/blog/7591475/los-artistas-de-miami-gen-wav-y-khr-s-joao-son-parte-de-una-nueva-ola-de-artistas-latinos-en-el-305" target="_blank" style={{color:"white", textDecoration:"none"}}>Somos La H Blog</a></h5>
             <h5 style={{marginBottom:"2%"}}><a href="https://canvasrebel.com/meet-gen-wav/" target="_blank" style={{color:"white", textDecoration:"none"}}>Canvas Rebel Article</a></h5>
             <h5 style={{marginBottom:"2%"}}><a href="https://colorsxstudios.com/music" target="_blank" style={{color:"white", textDecoration:"none"}}>Colors Studios Feature</a></h5>
             <h5 style={{marginBottom:"2%"}}><a href="https://voyagemia.com/interview/rising-stars-meet-genesis-barrios-of-little-havana" target="_blank" style={{color:"white", textDecoration:"none"}}>Voyage MIA Rising Stars Article</a></h5>
            <h5 style={{marginBottom:"2%"}}><a href="https://shoutoutmiami.com/meet-gen-wav-producer-engineer/" target="_blank" style={{color:"white", textDecoration:"none"}}>Shoutout Miami Article</a></h5>

          <h1 style={{marginTop:"8%", marginBottom:"3%"}}>LIVE PERFORMANCES</h1>
          <div style={{display:"grid", gridTemplateColumns:"repeat(2, minmax(0, 1fr))", columnGap:"12px", rowGap:"14px", marginBottom:"3%"}}>
            {[...LIVE_PERFORMANCES].sort((a, b) => Number(b.year) - Number(a.year)).map((v) => (
              <div key={v.name}>
                <p style={{margin:0}}>{v.name}</p>
                <p style={{margin:0, fontSize:"0.8em", opacity:0.7}}>{v.city} · {v.year}</p>
              </div>
            ))}
          </div>

              <div className="epk-bookings-mobile">{bookings}</div>

              <div className="epk-signup-mobile">{signupAndLinks}</div>

              {/* On mobile the left photo column is hidden: its top photo becomes the hero, the other starts the gallery here */}
              <div className="epk-mobile-photos">
                <img src="https://dl.dropboxusercontent.com/s/lgduzrail9tglaoo4orpg/IMG_5547.jpg?rlkey=mk5oacojh1yr23ij8s7vcyflt&dl=0" alt="gen.wav" style={{width:"80%", height:"auto", marginTop:"20px"}} />
              </div>
             
              <div style={{width:"80%", margin:"20px auto 0", aspectRatio:"4001 / 5580", overflow:"hidden", position:"relative"}}>
                <img src="https://dl.dropboxusercontent.com/s/8xsc91gqw8ptlcu74zdvz/genheadshotWHITE2025.jpg?rlkey=kqnfcd1ii8lfgjtghc5zv002v&st=64jx7pcr&dl=0" style={{position:"absolute", bottom:0, left:0, width:"100%", height:"auto"}}></img>
              </div>
              <img src="https://dl.dropboxusercontent.com/s/ur82i72cu1e3cfmyns202/genheadshot2025.jpg?rlkey=xruchuq224eqw28dkwwwj1cwe&st=on6pknh5&dl=0" style={{width:"80%", height:"auto"}}></img>
            <img src="https://dl.dropboxusercontent.com/s/fpp8gfykbfiv2vogvqdiz/genmars.JPG?rlkey=d1tqphrprhw19qrmgg3j8rdaq&st=pw8obfaq&dl=0" style={{width:"80%", height:"auto"}}></img>
            <img src="https://dl.dropboxusercontent.com/s/0k0dthq0harqvyhanepad/jan25marsgen.JPG?rlkey=ans55vpr6jze28hokxfjv2iyb&st=zcxys40z&dl=0" style={{width:"80%", height:"auto"}}></img>
            <img  src="https://dl.dropboxusercontent.com/s/wa45u8lpg3m46qb5vpb3/MOSSY.JPG?rlkey=oyo1p028d2nez5foooyxrw7cq&st=rw0kpoz1&dl=0" style={{width:"80%", height:"auto"}} />
            <img src="https://dl.dropboxusercontent.com/s/c41ne5b0btlx1kc9urmvh/lapeli3.png?rlkey=9ni7eowvcfj9zwhjw8kxtm9d0&st=4c4y2el8&dl=0" style={{width:"80%", height:"auto"}}></img>
            <img src="https://dl.dropboxusercontent.com/s/u2v0qvsuf2vpk7bn4b8rt/textinmelookup.JPG?rlkey=flyizkpk64y7wo72iudm1mzbm&st=y62c4vqe&dl=0"style={{width:"80%", height:"auto"}}></img>
            <img src="https://dl.dropboxusercontent.com/s/s7uw298wmbe9jfqsk6vdt/problemas-GROUP.JPG?rlkey=jipihcwm657c1igo3etxsa5dq&st=z523127u&dl=0" style={{width:"80%", height:"auto"}}></img>
            <img src="https://dl.dropboxusercontent.com/s/pcx5fqb915v3xy2t8ic9o/marsdalemami.JPG?rlkey=cogo5smiwq9be5l1ww0qdi06m&st=s3xkjzfg&dl=0" style={{width:"80%", height:"auto"}}></img>
          
          </div>
          </div>
        </Grid>
         
      </Grid>
   </div>
    );
        
};

export default EPK;
